// *Design Imports*
import "./partials.css";

const Footer = () => {
  return (
    <footer>
      <p>
        GitHub:{" "}
        <a
          href="https://github.com/dBish6"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://github.com/dBish6
        </a>
      </p>
      <p>
        Developer: <span>David Bishop</span>
      </p>
    </footer>
  );
};

export default Footer;
